import * as Types from '../../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type JobTaskDetailsFragment = { __typename: 'JobTask', id: string, legacyId: number, claimedBy?: string | null, deferredUntil?: string | null, finished?: string | null, graph?: any | null, jobType?: Types.JobType | null, message?: string | null, name?: string | null, queueGroup?: string | null, resourceGroupPin?: Types.ResourceGroupId | null, cascadeGroupId?: Types.ResourceGroupId | null, started?: string | null, state: Types.JobTaskState, taskType?: string | null, cascade: Array<{ __typename: 'JobTaskCascadeStep', resourceGroupId: Types.ResourceGroupId, label: string, platform: Types.ResourceGroupPlatform, status: Types.CascadeStepStatus, events: Array<{ __typename: 'JobTaskCascadeStepEvent', label: string, observedAt: string, message?: string | null, category: Types.CascadeStepEventCategory }> }>, createdBy: { __typename: 'User', id: string, legacyId: number, name: string }, organization: { __typename: 'Organization', id: string, legacyId: number, name?: string | null }, job?: { __typename: 'JobTask', id: string, legacyId: number, name?: string | null } | null, taskEvents: Array<{ __typename: 'JobTaskEvent', id: string, eventType: Types.JobTaskEventType, observedAt: string, message?: string | null, resourceGroupId?: Types.ResourceGroupId | null, advanceReason?: Types.CascadeAdvanceReason | null, instanceName?: string | null, machineType?: string | null, zone?: string | null, durationSeconds?: number | null, performedByName?: string | null, memoryStats?: any | null }> };

export type JobTaskDetailsQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  legacyId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type JobTaskDetailsQuery = { __typename: 'Query', item: { __typename: 'JobTask', id: string, legacyId: number, claimedBy?: string | null, deferredUntil?: string | null, finished?: string | null, graph?: any | null, jobType?: Types.JobType | null, message?: string | null, name?: string | null, queueGroup?: string | null, resourceGroupPin?: Types.ResourceGroupId | null, cascadeGroupId?: Types.ResourceGroupId | null, started?: string | null, state: Types.JobTaskState, taskType?: string | null, cascade: Array<{ __typename: 'JobTaskCascadeStep', resourceGroupId: Types.ResourceGroupId, label: string, platform: Types.ResourceGroupPlatform, status: Types.CascadeStepStatus, events: Array<{ __typename: 'JobTaskCascadeStepEvent', label: string, observedAt: string, message?: string | null, category: Types.CascadeStepEventCategory }> }>, createdBy: { __typename: 'User', id: string, legacyId: number, name: string }, organization: { __typename: 'Organization', id: string, legacyId: number, name?: string | null }, job?: { __typename: 'JobTask', id: string, legacyId: number, name?: string | null } | null, taskEvents: Array<{ __typename: 'JobTaskEvent', id: string, eventType: Types.JobTaskEventType, observedAt: string, message?: string | null, resourceGroupId?: Types.ResourceGroupId | null, advanceReason?: Types.CascadeAdvanceReason | null, instanceName?: string | null, machineType?: string | null, zone?: string | null, durationSeconds?: number | null, performedByName?: string | null, memoryStats?: any | null }> } };

export type UpdateJobTaskDetailsMutationVariables = Types.Exact<{
  input: Types.MutationUpdateJobTaskInput;
}>;


export type UpdateJobTaskDetailsMutation = { __typename: 'Mutation', item: { __typename: 'JobTask', id: string, legacyId: number, claimedBy?: string | null, deferredUntil?: string | null, finished?: string | null, graph?: any | null, jobType?: Types.JobType | null, message?: string | null, name?: string | null, queueGroup?: string | null, resourceGroupPin?: Types.ResourceGroupId | null, cascadeGroupId?: Types.ResourceGroupId | null, started?: string | null, state: Types.JobTaskState, taskType?: string | null, cascade: Array<{ __typename: 'JobTaskCascadeStep', resourceGroupId: Types.ResourceGroupId, label: string, platform: Types.ResourceGroupPlatform, status: Types.CascadeStepStatus, events: Array<{ __typename: 'JobTaskCascadeStepEvent', label: string, observedAt: string, message?: string | null, category: Types.CascadeStepEventCategory }> }>, createdBy: { __typename: 'User', id: string, legacyId: number, name: string }, organization: { __typename: 'Organization', id: string, legacyId: number, name?: string | null }, job?: { __typename: 'JobTask', id: string, legacyId: number, name?: string | null } | null, taskEvents: Array<{ __typename: 'JobTaskEvent', id: string, eventType: Types.JobTaskEventType, observedAt: string, message?: string | null, resourceGroupId?: Types.ResourceGroupId | null, advanceReason?: Types.CascadeAdvanceReason | null, instanceName?: string | null, machineType?: string | null, zone?: string | null, durationSeconds?: number | null, performedByName?: string | null, memoryStats?: any | null }> } };

export type UpdateJobTaskResourceGroupDetailsMutationVariables = Types.Exact<{
  input: Types.MutationUpdateJobTaskResourceGroupInput;
}>;


export type UpdateJobTaskResourceGroupDetailsMutation = { __typename: 'Mutation', item: { __typename: 'JobTask', id: string, legacyId: number, claimedBy?: string | null, deferredUntil?: string | null, finished?: string | null, graph?: any | null, jobType?: Types.JobType | null, message?: string | null, name?: string | null, queueGroup?: string | null, resourceGroupPin?: Types.ResourceGroupId | null, cascadeGroupId?: Types.ResourceGroupId | null, started?: string | null, state: Types.JobTaskState, taskType?: string | null, cascade: Array<{ __typename: 'JobTaskCascadeStep', resourceGroupId: Types.ResourceGroupId, label: string, platform: Types.ResourceGroupPlatform, status: Types.CascadeStepStatus, events: Array<{ __typename: 'JobTaskCascadeStepEvent', label: string, observedAt: string, message?: string | null, category: Types.CascadeStepEventCategory }> }>, createdBy: { __typename: 'User', id: string, legacyId: number, name: string }, organization: { __typename: 'Organization', id: string, legacyId: number, name?: string | null }, job?: { __typename: 'JobTask', id: string, legacyId: number, name?: string | null } | null, taskEvents: Array<{ __typename: 'JobTaskEvent', id: string, eventType: Types.JobTaskEventType, observedAt: string, message?: string | null, resourceGroupId?: Types.ResourceGroupId | null, advanceReason?: Types.CascadeAdvanceReason | null, instanceName?: string | null, machineType?: string | null, zone?: string | null, durationSeconds?: number | null, performedByName?: string | null, memoryStats?: any | null }> } };

export const JobTaskDetailsFragmentDoc = gql`
    fragment JobTaskDetails on JobTask {
  __typename
  id
  legacyId
  claimedBy
  deferredUntil
  finished
  graph
  jobType
  message
  name
  queueGroup
  resourceGroupPin
  cascadeGroupId
  cascade {
    resourceGroupId
    label
    platform
    status
    events {
      label
      observedAt
      message
      category
    }
  }
  started
  state
  taskType
  createdBy {
    id
    legacyId
    name
  }
  organization {
    id
    legacyId
    name
  }
  job {
    id
    legacyId
    name
  }
  taskEvents {
    id
    eventType
    observedAt
    message
    resourceGroupId
    advanceReason
    instanceName
    machineType
    zone
    durationSeconds
    performedByName
    memoryStats
  }
}
    `;
export const JobTaskDetailsDocument = gql`
    query jobTaskDetails($id: ID, $legacyId: Int) {
  item: jobTask(id: $id, legacyId: $legacyId) {
    ...JobTaskDetails
  }
}
    ${JobTaskDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class JobTaskDetailsGQL extends Apollo.Query<JobTaskDetailsQuery, JobTaskDetailsQueryVariables> {
    override document = JobTaskDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateJobTaskDetailsDocument = gql`
    mutation updateJobTaskDetails($input: MutationUpdateJobTaskInput!) {
  item: updateJobTask(input: $input) {
    ...JobTaskDetails
  }
}
    ${JobTaskDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateJobTaskDetailsGQL extends Apollo.Mutation<UpdateJobTaskDetailsMutation, UpdateJobTaskDetailsMutationVariables> {
    override document = UpdateJobTaskDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateJobTaskResourceGroupDetailsDocument = gql`
    mutation updateJobTaskResourceGroupDetails($input: MutationUpdateJobTaskResourceGroupInput!) {
  item: updateJobTaskResourceGroup(input: $input) {
    ...JobTaskDetails
  }
}
    ${JobTaskDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateJobTaskResourceGroupDetailsGQL extends Apollo.Mutation<UpdateJobTaskResourceGroupDetailsMutation, UpdateJobTaskResourceGroupDetailsMutationVariables> {
    override document = UpdateJobTaskResourceGroupDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }